// Menu data extracted from photos with multilingual support
export const menuItems = {
  bogavante: [
    {
      name: 'Menú Completo de Bogavante',
      description: 'Complete Lobster Menu - 4 courses included:\n\n\n• Lobster Cappuccino\n• ½ Lobster Salad\n• ½ Lobster with cream and vegetables or garlic butter\n• Dessert',
      translations: {
        french: 'Menu Complet de Homard - 4 services inclus:\n\n\n• Cappuccino de Homard\n• ½ Salade de Homard\n• ½ Homard à la crème et légumes ou beurre à l\'ail\n• Dessert',
        dutch: 'Compleet Kreeft Menu - 4 gangen inbegrepen:\n\n\n• Kreeft Cappuccino\n• ½ Kreeft Salade\n• ½ Kreeft met room en groenten of knoflookboter\n• Dessert',
        english: 'Complete Lobster Menu - 4 courses included:\n\n\n• Lobster Cappuccino\n• ½ Lobster Salad\n• ½ Lobster with cream and vegetables or garlic butter\n• Dessert',
        german: 'Komplettes Hummer-Menü - 4 Gänge enthalten:\n\n\n• Hummer-Cappuccino\n• ½ Hummer-Salat\n• ½ Hummer mit Sahne und Gemüse oder Knoblauchbutter\n• Dessert'
      },
      price: '42€'
    }
  ],
  sopas: [
    {
      name: 'Sopa del día',
      description: 'Soup of the day',
      translations: {
        french: 'Soupe du jour',
        dutch: 'Soep van de dag',
        english: 'Soup of the day',
        german: 'Tagessuppe'
      },
      price: '6,50€'
    },
    {
      name: 'Sopa de pescado',
      description: 'Fish soup',
      translations: {
        french: 'Soupe de poisson',
        dutch: 'Vissoep',
        english: 'Fish soup',
        german: 'Fischsuppe'
      },
      price: '9,50€'
    }
  ],
  entradas: [
    {
      name: 'Ensalada de Gambas al ajillo con salpicon de aguacate y tomate',
      description: 'Shrimp salad with garlic, chopped, tomato and avocado',
      translations: {
        french: 'Salade de crevettes à l\'ail et tartare d\'avocat et tomate',
        dutch: 'Salade van garnaalen met knoflook en salpicon avocaten tomate',
        english: 'Shrimp salad with garlic,chopped,tomato and avocado',
        german: 'Garnalen-Salad mit Knoblauch,Tomate und Avocado'
      },
      price: '15,50€'
    },
    {
      name: 'Ensalada de atún',
      description: 'Tuna salad',
      translations: {
        french: 'Salade de thon',
        dutch: 'Salade van tonijn',
        english: 'Tuna salad',
        german: 'Thunfisch salat'
      },
      price: '12,00€'
    },
    {
      name: 'Ensalada de pato con helado de queso de cabra y fruta roja',
      description: 'Duck Ham salad with goat cheese ice cream and red fruits',
      translations: {
        french: 'Salad avec jamon du canard et glace au fromage de chèvre et fruits rouges',
        dutch: 'Eendenham salade met geitenkaas ijs en rode vruchten',
        english: 'Duck Ham salad with goat cheese ice cream and red fruits',
        german: 'Entenschinken salat mit Ziegenkäese Eis und Weichobs'
      },
      price: '14,50€'
    },
    {
      name: 'Carpaccio de ternera',
      description: 'Beef carpaccio',
      translations: {
        french: 'Carpaccio de boeuf',
        dutch: 'Carpaccio van rundevlees',
        english: 'Beef carpaccio'
      },
      price: '12,50€'
    },
    {
      name: 'Tartar de Atun con aguacate',
      description: 'Tuna tartare with avocado',
      translations: {
        french: 'Tartare de Thon avec avocat',
        dutch: 'Tonijtartar met avocado',
        english: 'Tuna tartare with avocado',
        german: 'Thunfischtartar mit Avocado'
      },
      price: '16,50€'
    },
    {
      name: 'Foie gras de pato casero con mermelada de cebolla',
      description: 'Terrine of Foie gras with onion jam',
      translations: {
        french: 'Foie gras de canard "fait maison" avec confiture d\'oignons',
        dutch: 'Ganzelever terrine met ajuinconfituur',
        english: 'Terrine of Foie gras with onion jam',
        german: 'Gänsestopfleber mit Zwiebelemarmelade'
      },
      price: '19,00€'
    },
    {
      name: 'Tartar de bacalao ahumado',
      description: 'Smoked codfish tartare',
      translations: {
        french: 'Tartare de morue fumée',
        dutch: 'Tartaar van gerookte kabeljaw',
        english: 'Smoked codfish tartare',
        german: 'Tartar vom geräucherten kabeljau'
      },
      price: '14,00€'
    },
    {
      name: 'Ensalada de bogavante "parisien"',
      description: 'Lobstersalad Parisien Style',
      translations: {
        french: 'Salade de homard à la parisienne',
        dutch: 'Kreeft salade aan de parijse',
        english: 'Lobstersalad Parisien Style',
        german: 'Hummer salat nach Pariser Art'
      },
      price: '35,00€ (1/1) / 19,00€ (1/2)'
    },
    {
      name: 'Salmon marinado con crema de cebollino',
      description: 'Marinated salmon with chive cream',
      translations: {
        french: 'Saumon mariné à la crème de ciboulette',
        dutch: 'Gemarineerde zalm met bieslook room',
        english: 'Marinated salmon with chive cream',
        german: 'Marinierter Lachs mit Schnittauch Rahmsauce'
      },
      price: '16,00€'
    }
  ],
  entradasCalientes: [
    {
      name: 'Croquetas de queso',
      description: 'Cheese croquettes',
      translations: {
        french: 'Croquettes aux fromage',
        dutch: 'Kaaskroketjes',
        english: 'Cheese croquettes',
        german: 'Käsekroketten'
      },
      price: '12,00€'
    },
    {
      name: 'Croquetas de gambitas grises',
      description: 'Grey shrimp croquettes',
      translations: {
        french: 'Croquettes aux crevettes',
        dutch: 'Garnaalkroketjes',
        english: 'Grey shrimp croquettes',
        german: 'Garnalenkroketten'
      },
      price: '16,00€'
    },
    {
      name: 'Scampis "diabolo" en crema picante',
      description: 'Scampis "devil" in spicy sauce',
      translations: {
        french: 'Scampis "diable" sauce piquante',
        dutch: 'Scampis "duivel" pikante saus',
        english: 'Scampis "devil" in spicy sauce',
        german: 'Scampis "Teufel" mit pikanter Sauce'
      },
      price: '15,50€ (6 piezas) / 19,00€ (10 piezas)'
    },
    {
      name: 'Ancas de rana (mantequilla, ajo y perejil)',
      description: 'Frog legs in butter and garlic',
      translations: {
        french: 'Cuisses de grenouilles à la bourguignonne',
        dutch: 'Kikkerbillen met lookboter',
        english: 'Frog legs in butter and garlic',
        german: 'Froschschenkel mit Butter und Knoblauch'
      },
      price: '12,00€'
    },
    {
      name: 'Caracoles en Hojaldre (Salsa de tomate, ajo y nata)',
      description: 'Snails in puff pastry (garlic, cream and tomato)',
      translations: {
        french: 'Milles feuilles aux escargots (ail,crème et tomate)',
        dutch: 'Slakken gevuld in bladerdeeg (look,room en tomaat)',
        english: 'Snails in puff pastry (garlic,cream and tomato)',
        german: 'Schnecken im Blätterteig(Sahne,knoblauch und Tomate )'
      },
      price: '12,50€'
    },
    {
      name: 'Escalope de foie gras salteado con manzana y salsa porto',
      description: 'Sautéed foie gras escalope with appel and porto sauce',
      translations: {
        french: 'Escalope de foie gras poêlée aux pommes sauce porto',
        dutch: 'Gebakken foie gras met appel en portosaus',
        english: 'Sautéed foie gras escalope with appel and porto sauce',
        german: 'Gebratene Entenleber mit Äpfel und Portoweinsoauce'
      },
      price: '22,00€'
    },
    {
      name: 'Vieiras gratinadas',
      description: 'Scallops au gratin',
      translations: {
        french: 'Coquilles Saint-Jacques au gratin',
        dutch: 'Gegratineerde Sint-Jakobsschelpen',
        english: 'Scallops au gratin',
        german: 'Gratinierte Jakobsmuscheln'
      },
      price: '17,00€'
    }
  ],
  pasta: [
    {
      name: 'Spaguetti Bolognesa',
      description: 'Spaghetti Bolognese',
      translations: {
        french: 'Spaghetti Bolognese',
        dutch: 'Spaghetti Bolognaise',
        english: 'Spaghetti Bolognese'
      },
      price: '13,00€'
    },
    {
      name: 'Lasagna Casera',
      description: 'Homemade lasagna',
      translations: {
        french: 'Lasagna maison',
        dutch: 'Homemade lasagna',
        english: 'Homemade lasagna'
      },
      price: '13,00€'
    }
  ],
  carnes: [
    {
      name: 'Steak tarta (preparado a su gusto con fritas)',
      description: 'Steak tartar (made to your liking with chips and salad)',
      translations: {
        french: 'Steak tartare (préparé à votre goût,frites,salade)',
        dutch: 'Steak tartar (bereid naar uw wens met friten end salade)',
        english: 'Steak tartar (made to your liking with chips and salad)',
        german: 'Steak tatar (nach Ihrem Wunsch zubereitet mit Frites und salat)'
      },
      price: '19,00€'
    },
    {
      name: 'Estofado de ternera con cerveza y sirope de ciruelas',
      description: 'Beef stew with beer and liège syrup',
      translations: {
        french: 'Carbonade de boeuf à la bière et sirop de Liège',
        dutch: 'Stoofvlees op limburgse wijze',
        english: 'Beef stew with beer and liège syrup',
        german: 'Rinderschmorbraten mit Bier und Lütticher Sirup'
      },
      price: '16,50€'
    },
    {
      name: 'Hojaldre relleno de pollo con champiñon y nata',
      description: 'Chicken in puff pastry with mushroom sauce',
      translations: {
        french: 'Bouchée à la reine',
        dutch: 'Koninginnehapje',
        english: 'Chicken in puff pastry with mushroom sauce',
        german: 'Königingspastete mit Hühnchen unel Champignonsauce'
      },
      price: '16,00€'
    },
    {
      name: 'Magret de pato asado con salsa de naranja',
      description: 'Roast Duck breast (magret) with oranje sauce',
      translations: {
        french: 'Magret de canard avec sauce à l\'orange',
        dutch: 'Gebraden eendenborst met sinaasappelsaus',
        english: 'Roast Duck breast (magret) with oranje sauce'
      },
      price: '21,00€'
    },
    {
      name: 'Chuleta de Ternera lechal con salsa de Jamon Iberico',
      description: 'Milk-fed veal chop with Iberian Ham sauce',
      translations: {
        french: 'Côte de veau sauce au jambon Iberique',
        dutch: 'Kalfsvlees kotelet met Iberico Ham Sauce',
        english: 'Milk-fed veal chop with Iberian Ham sauce',
        german: 'Kalbskotelett mit Iberischer Shinken sauce'
      },
      price: '21,00€'
    },
    {
      name: 'Solomillo de ternera con foie gras y reduccion de Pedro Ximenez',
      description: 'Fillet of beef with foie gras and Perdo Ximenez sauce',
      translations: {
        french: 'Filet de boeuf au foie gras et réduction de Pedro Ximenez',
        dutch: 'Ossenhaas met foie gras en Pedro Ximenez saus',
        english: 'Fillet of beef with foie gras and Perdo Ximenez sauce',
        german: 'Rinderfilet mit Entenleber und Pedro Ximenez Sauce'
      },
      price: '28,00€'
    },
    {
      name: 'Steak Nou Valentino (queso de cabra y mermelada de pimientos)',
      description: 'Beef steak Nou Valentino (goat cheese and pepper jam)',
      translations: {
        french: 'Steak Nou Valentino (fromage de chèvre et marmelade de poivrons)',
        dutch: 'Biefstuk Nou Valentino (geitenkaas end paprika jam)',
        english: 'Beef steak Nou Valentino (goat cheese and pepper jam)',
        german: 'Rindersteak Nou Valentino (Ziegenkäese und Rucola)'
      },
      price: '20,00€'
    },
    {
      name: 'Steak "Atomiun" (pimienta negra, nata, flambeado al Brandy)',
      description: 'Beef steak "Atomiun" (black pepper, cream, flambé in Brandy)',
      translations: {
        french: 'Steak "Atomiun" (poivre noir,crème flambée au Brandy)',
        dutch: 'Biefstuk "Atomiun" (zwarte peper,room,geflambeerd met Brandy)',
        english: 'Beef steak "Atomiun" (black pepper,cream,flambé in Brandy)',
        german: 'Rindersteak "Atomiun" (schwarzer Pfeffer,Sahne,flambiert in Brandy)'
      },
      price: '19,00€'
    },
    {
      name: 'Steak con salsa Gorgonzola',
      description: 'Steak with Gorgonzola Sauce',
      translations: {
        french: 'Steak avec sauce Gorgonzola',
        dutch: 'Biefstuk met Gorgonzolasaus',
        english: 'Steak with Gorgonzola Sauce',
        german: 'Steak mit Gorgonzola-Sauce'
      },
      price: '20,00€'
    }
  ]
};

export const menuCategories = [
  { id: 'bogavante', label: 'MENÚ BOGAVANTE' },
  { id: 'sopas', label: 'SOPAS' },
  { id: 'entradas', label: 'ENTRADAS FRÍAS' },
  { id: 'entradasCalientes', label: 'ENTRADAS CALIENTES' },
  { id: 'pasta', label: 'PASTA' },
  { id: 'carnes', label: 'CARNES' }
];